export const DATE_FORMAT = {
    YYYY年M月D日: "YYYY年M月D日"
} as const;
